var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/assets/Solutions.tsx",
  _this = this;
import React from 'react';
var SolutionsIcon = function SolutionsIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2v6.257c.627.043 1.25.126 1.866.249a10.527 10.527 0 0 1 7.367 15.433l-3.725-2.528a6.072 6.072 0 1 1-6.75-8.503c.411-.061.827-.079 1.242-.053v2.812",
    stroke: "#6BC9F5",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.18a3.305 3.305 0 1 0 0-6.61 3.305 3.305 0 0 0 0 6.61Z",
    fill: "#9D9D9D",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.257 6.286a12.792 12.792 0 1 1-4.514 0",
    stroke: "#404040",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.718 24.854A8.276 8.276 0 0 1 8.08 16.468M6.813 9.967l3.054 3.053.126-.133A8.285 8.285 0 0 1 24 18.873a8.426 8.426 0 0 1-.2 1.847M25.044 27.92l-3.182-3.184",
    stroke: "#404040",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.613 13.26-2.96 2.96.003-.002c.524.512.88 1.17 1.024 1.889a3.759 3.759 0 1 1-6.298-1.93",
    stroke: "#404040",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 4.4 16 2l-2.4 2.4",
    stroke: "#6BC9F5",
    strokeWidth: "2",
    strokeLinecap: "round",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }));
};
export default SolutionsIcon;
//# sourceMappingURL=Solutions.js.map